import { render, staticRenderFns } from "./properties-header.vue?vue&type=template&id=376fce16&scoped=true"
import script from "./properties-header.vue?vue&type=script&lang=js"
export * from "./properties-header.vue?vue&type=script&lang=js"
import style0 from "./properties-header.vue?vue&type=style&index=0&id=376fce16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fce16",
  null
  
)

export default component.exports